import { render, staticRenderFns } from "./mailing_address.vue?vue&type=template&id=13cdaf4e"
import script from "./mailing_address.vue?vue&type=script&lang=js"
export * from "./mailing_address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports